import { render, staticRenderFns } from "./gen3.vue?vue&type=template&id=2cca276c&scoped=true"
import script from "./gen3.vue?vue&type=script&lang=js"
export * from "./gen3.vue?vue&type=script&lang=js"
import style0 from "./gen3.vue?vue&type=style&index=0&id=2cca276c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cca276c",
  null
  
)

export default component.exports